var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn investigation-screen"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "investigation-filter-card"
  }, [_c('div', {
    staticClass: "investigation-filter-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchUserData()
      }
    }
  }, [_c('div', {
    staticClass: "filter-grid"
  }, [_c('div', {
    staticClass: "filter-field"
  }, [_vm._m(1), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "newhubs",
      "options": _vm.newhublist,
      "placeholder": "Enter Zone",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": function($event) {
        _vm.callHub(_vm.newhubs)
      }
    },
    model: {
      value: (_vm.newhubs),
      callback: function($$v) {
        _vm.newhubs = $$v
      },
      expression: "newhubs"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newhubs')),
      expression: "errors.has('newhubs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newhubs')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("\n                Hub/SVC\n                "), (!_vm.newhubs || !_vm.newhubs.id) ? _c('span', {
    staticClass: "field-note-inline"
  }, [_vm._v("Select Hub Zone first")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "hub",
      "options": _vm.hublist,
      "disabled": !_vm.newhubs || !_vm.newhubs.id,
      "placeholder": (!_vm.newhubs || !_vm.newhubs.id) ? 'Select Hub Zone first' : 'Enter hub',
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.hub),
      callback: function($$v) {
        _vm.hub = $$v
      },
      expression: "hub"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hub')),
      expression: "errors.has('hub')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Hub/SVC.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Shipment Value")]), _vm._v(" "), _c('div', {
    staticClass: "octroi-field-group"
  }, [_c('Multiselect', {
    attrs: {
      "name": "operator",
      "options": _vm.operatorOptions,
      "placeholder": "-",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.operator),
      callback: function($$v) {
        _vm.operator = $$v
      },
      expression: "operator"
    }
  }), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal:2'),
      expression: "'decimal:2'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('detended_days_octroi_MRP')
    },
    attrs: {
      "id": "octroi_MRP",
      "disabled": _vm.checkDisabled,
      "name": "octroi_MRP",
      "placeholder": "Enter Amount",
      "type": "text"
    },
    model: {
      value: (_vm.octroi_MRP),
      callback: function($$v) {
        _vm.octroi_MRP = $$v
      },
      expression: "octroi_MRP"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('octroi_MRP')),
      expression: "errors.has('octroi_MRP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Shipment Value is required & Enter only number.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "Status",
      "options": _vm.StatusList,
      "placeholder": "Select  Status",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": function($event) {
        _vm.callVstatusList(_vm.Status)
      }
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Status')),
      expression: "errors.has('Status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("status is required.")])]), _vm._v(" "), (!_vm.WHHandover) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Verification Status")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "vStatus",
      "options": _vm.vStatusList,
      "placeholder": "Select Verification Status",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.vStatus),
      callback: function($$v) {
        _vm.vStatus = $$v
      },
      expression: "vStatus"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('vStatus')),
      expression: "errors.has('vStatus')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("verification status is required.")])]) : _vm._e(), _vm._v(" "), (_vm.WHHandover) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Dispute Status")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "disputeStatus",
      "disabled": "",
      "name": "disputeStatus",
      "placeholder": "Dispute Draft",
      "type": "text"
    },
    model: {
      value: (_vm.disputeStatus),
      callback: function($$v) {
        _vm.disputeStatus = $$v
      },
      expression: "disputeStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.WHHandover) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "shipmentType",
      "options": _vm.shipmentTypeList,
      "placeholder": "Enter Shipment Type",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": function($event) {
        _vm.fetchDisputeReasons(_vm.shipmentType)
      }
    },
    model: {
      value: (_vm.shipmentType),
      callback: function($$v) {
        _vm.shipmentType = $$v
      },
      expression: "shipmentType"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentType')),
      expression: "errors.has('shipmentType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('shipmentType')))])], 1) : _vm._e(), _vm._v(" "), (_vm.WHHandover) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "client",
      "options": _vm.clientList,
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "label",
      "multiple": true,
      "close-on-select": false
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('client')),
      expression: "errors.has('client')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Client name is required.")])]) : _vm._e(), _vm._v(" "), (_vm.WHHandover) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Ageing of the Dispute")]), _vm._v(" "), _c('div', {
    staticClass: "octroi-field-group"
  }, [_c('Multiselect', {
    attrs: {
      "name": "daysOperator",
      "options": _vm.daysOperatorOptions,
      "placeholder": "-",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.daysOperator),
      callback: function($$v) {
        _vm.daysOperator = $$v
      },
      expression: "daysOperator"
    }
  }), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal:2'),
      expression: "'decimal:2'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('numberOfDays')
    },
    attrs: {
      "id": "numberOfDays",
      "disabled": _vm.checkDisabledDays,
      "name": "numberOfDays",
      "placeholder": "Enter number of days",
      "type": "text"
    },
    model: {
      value: (_vm.numberOfDays),
      callback: function($$v) {
        _vm.numberOfDays = $$v
      },
      expression: "numberOfDays"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('octroi_MRP')),
      expression: "errors.has('octroi_MRP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("number of days is required & Enter only number.")])]) : _vm._e(), _vm._v(" "), (_vm.WHHandover) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Dispute Reason")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "disputeReason",
      "options": _vm.disputeReasonList,
      "placeholder": "Select dispute reason",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.disputeReason),
      callback: function($$v) {
        _vm.disputeReason = $$v
      },
      expression: "disputeReason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('disputeReason')),
      expression: "errors.has('disputeReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("dispute reason is required.")])]) : _vm._e(), _vm._v(" "), (_vm.WHHandover) ? _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Assignee Name")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "assignee",
      "options": _vm.assignUserList,
      "placeholder": "Select assignee name",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.assignee),
      callback: function($$v) {
        _vm.assignee = $$v
      },
      expression: "assignee"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('assignee')),
      expression: "errors.has('assignee')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Assignee name is required.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Manifest Date (From/To)")]), _vm._v(" "), _c('div', {
    staticClass: "date-range-group"
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.manifestFromDate),
      callback: function($$v) {
        _vm.manifestFromDate = $$v
      },
      expression: "manifestFromDate"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.manifestToDate),
      callback: function($$v) {
        _vm.manifestToDate = $$v
      },
      expression: "manifestToDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Investigation Status")]), _vm._v(" "), _c('div', {
    staticClass: "field-loading-wrap"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    attrs: {
      "name": "investigationStatus",
      "options": _vm.investigationStatusOptions,
      "placeholder": "Select Status",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.investigationStatus),
      callback: function($$v) {
        _vm.investigationStatus = $$v
      },
      expression: "investigationStatus"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', {
    staticClass: "label-nowrap"
  }, [_vm._v("Investigation Logged Date (From/To)")]), _vm._v(" "), _c('div', {
    staticClass: "date-range-group"
  }, [_c('b-form-input', {
    attrs: {
      "id": "fromdate",
      "name": "fromdate",
      "type": "date"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "todate",
      "name": "todate",
      "type": "date"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-footer"
  }, [_c('div', {
    staticClass: "awb-field"
  }, [_c('label', [_vm._v("AWB Number")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }],
    staticClass: "form-control awb-textarea",
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "placeholder": "Enter AWB Numbers",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v("Use Comma(,) for Multiple AWB Numbers")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "AWB"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWB')),
      expression: "errors.has('AWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("AWB Number is required.")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-action-buttons"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.ExportDisableds,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exportfileCSV()
      }
    }
  }, [_vm._v("Export "), _c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.searchUserData()
      }
    }
  }, [_vm._v(" Search "), _c('i', {
    staticClass: "fa fa-search"
  })])])])])])]), _vm._v(" "), (_vm.hasSearched && !_vm.show2 && !_vm.listUserData.length) ? _c('div', {
    staticClass: "investigation-empty-state"
  }, [_vm._m(2), _vm._v(" "), _c('h3', [_vm._v("No Search Results")]), _vm._v(" "), _c('p', [_vm._v("Adjust your filters above and click \"Search\" to view shipment details.")])]) : _vm._e(), _vm._v(" "), (_vm.isLoading1) ? _c('div', {
    staticClass: "col-12 p-0"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.show2,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#000080"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Shipment Details "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("(Total Records :" + _vm._s(_vm.totalcount) + ")")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), (_vm.showBulk) ? _c('div', [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "actionToggle"
    },
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v("Select Bulk\n        Accept Dispute\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.showBulk) ? _c('div', [_c('b-link', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        _vm.acceptDispute(_vm.bulkAWB)
      }
    }
  }, [_vm._v("Accept Dispute")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    ref: "table",
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_vm._m(3), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Investigation Aging")]), _vm._v(" "), _c('span', {
    staticClass: "sort-icons"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up",
    class: {
      active: _vm.sortColumn === 'pendingdays' && _vm.sortDirection === 'asc'
    },
    on: {
      "click": function($event) {
        _vm.sortTable('pendingdays', 'asc')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-down",
    class: {
      active: _vm.sortColumn === 'pendingdays' && _vm.sortDirection === 'desc'
    },
    on: {
      "click": function($event) {
        _vm.sortTable('pendingdays', 'desc')
      }
    }
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OctroiMRP")]), _vm._v(" "), _c('span', {
    staticClass: "sort-icons"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up",
    class: {
      active: _vm.sortColumn === 'netvalue' && _vm.sortDirection === 'asc'
    },
    on: {
      "click": function($event) {
        _vm.sortTable('netvalue', 'asc')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-down",
    class: {
      active: _vm.sortColumn === 'netvalue' && _vm.sortDirection === 'desc'
    },
    on: {
      "click": function($event) {
        _vm.sortTable('netvalue', 'desc')
      }
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Logged Date")]), _vm._v(" "), (_vm.showBulk) ? _c('div', [_c('div', [_c('i', {
    staticClass: "fa fa-arrow-up",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.sortingEvent($event, 'Asc')
      }
    }
  })]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-arrow-down",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.sortingEvent($event, 'Desc')
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32)])]), _vm._v(" "), (_vm.editshowtable) ? _c('tbody', [(_vm.totalcount == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "colspan": "31",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedList), function(data, i) {
    return _c('tr', [_c('td', {
      staticClass: "action-td"
    }, [(data.isactive || _vm.isWHHandoverShipment(data)) ? [((!data.editable) && !(_vm.isWHHandoverShipment(data) && !data.isactive)) ? _c('span', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "align": "center"
      }
    }, [_vm._v("Not Editable")]) : _vm._e(), _vm._v(" "), ((data.editable) && !_vm.isWHHandoverShipment(data)) ? _c('b-link', {
      staticClass: "btn btn-sm btn-info action-btn",
      on: {
        "click": function($event) {
          _vm.neweditpage(data.shippingid, data.currenthubid, data.status, data.id, data.declaredvalue, data.previousshipmentstatus)
        }
      }
    }, [_vm._v("Take Action")]) : _vm._e(), _vm._v(" "), (((data.editable) || (_vm.isWHHandoverShipment(data) && !data.isactive)) && _vm.isWHHandoverShipment(data)) ? _c('b-link', {
      staticClass: "btn btn-sm btn-info action-btn",
      on: {
        "click": function($event) {
          _vm.newEditDraftPage(data.shippingid, data.clientid, data.actionstatuscode )
        }
      }
    }, [_vm._v("Action On Draft")]) : _vm._e()] : [_c('span', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "align": "center"
      }
    }, [_vm._v("Not Editable")])]], 2), _vm._v(" "), _c('td', [((!data.isactive)) ? _c('span', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "align": "center"
      }
    }, [_vm._v("CLOSED")]) : _vm._e(), _vm._v(" "), ((data.isactive)) ? _c('span', [_vm._v(_vm._s(data.pendingdays))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.netvalue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.disputeamount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.regionname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.finaldestinationname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.disputemarkedonhubname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientreason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientsubreason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.loggeddescription))]), _vm._v(" "), _c('td', {
      staticClass: "action-td"
    }, [_vm._v(_vm._s(data.disputstatusname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ordertype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.phyweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.volweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createddate ? new Date(data.createddate).toLocaleDateString() : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.loggeddescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.coloaderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.bagcondition))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productinformation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Statusname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.VerificationStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.stdbagcondition))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.lastmodifieddate ? new Date(data.lastmodifieddate).toLocaleDateString() : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shortagetype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.recreasionname))]), _vm._v(" "), (_vm.abc == '' || _vm.abc !== data.shippingid) ? _c('td', [_c('b-link', {
      staticClass: "btn btn-sm btn-info",
      on: {
        "click": function($event) {
          _vm.ImageView(data.shippingid, data.status)
        }
      }
    }, [_c('i', {
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("View")])], 1) : (_vm.abc !== '' || _vm.abc == data.shippingid) ? _c('td', [_vm._l((_vm.List), function(d) {
      return _c('div', [_c('b-link', {
        on: {
          "click": function($event) {
            _vm.downloadImage(d.Key)
          }
        }
      }, [_c('i', {
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v("Image")]), _vm._v(" "), _c('a', {
        attrs: {
          "href": _vm.link + d.Key
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true"
        }
      })])], 1)
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "13px"
      }
    }, [_vm._v("\n\n                " + _vm._s(_vm.errormsg) + "\n                ")])], 2) : _vm._e()])
  })], 2) : _vm._e()])]), _c('br'), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "force-page": _vm.pageValue,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF0000"
    }
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "BootstrapVue"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "active": _vm.show1,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#00FFFF"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "download-btn"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.imgData,
      "download": ""
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeImage()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgData,
      "alt": "Loading...."
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-wrapper",
    attrs: {
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showSTDModal),
      callback: function($$v) {
        _vm.showSTDModal = $$v
      },
      expression: "showSTDModal"
    }
  }, [
    [_c('h5', {
      staticClass: "modal-title"
    }, [_vm._v("Logged Images/Videos:")]), _vm._v(" "), _c('span', {
      staticClass: "close",
      attrs: {
        "aria-label": "Close"
      },
      on: {
        "click": _vm.closeSTDModal
      }
    }, [_vm._v("X")])], _vm._v(" "), (_vm.STDassets && _vm.STDassets.clientImages && _vm.STDassets.clientImages.length) ? _c('div', [_c('div', {
      staticClass: "modal-content text-center"
    }, _vm._l((_vm.STDassets.clientImages), function(img, index) {
      return _c('div', {
        key: index
      }, [(img.attachment) ? _c('img', {
        staticClass: "main-image img-fluid",
        attrs: {
          "src": img.attachment,
          "alt": "Image Preview"
        }
      }) : _vm._e()])
    }))]) : _vm._e(), _vm._v(" "), (_vm.STDassets && _vm.STDassets.videourl && _vm.STDassets.videourl.length) ? _c('div', [_c('div', {
      staticClass: "modal-content text-center"
    }, _vm._l((_vm.STDassets.videourl), function(vid, index) {
      return _c('div', {
        key: index
      }, [(vid.UnboxingVideoProof1) ? _c('video', {
        staticClass: "inv-video-preview",
        attrs: {
          "src": vid.UnboxingVideoProof1,
          "controls": ""
        }
      }, [_vm._v("\n            Your browser does not support the video tag.\n          ")]) : _vm._e()])
    }))]) : _vm._e()
  ], 2)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "investigation-page-header"
  }, [_c('div', {
    staticClass: "investigation-page-title"
  }, [_c('div', {
    staticClass: "title-icon"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("Action Required By CLT/KAM Team")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Hub Zone "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-state-icon"
  }, [_c('i', {
    staticClass: "fa fa-search-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("AWB Number")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Amount")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Region")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current HubName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin HubName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination HubName")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Marked On Facility")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Reason")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Sub-Reason")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comments")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Satus Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DEPS Logged By")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Order Type")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Physical Weight")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Volumetric Weight")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Logged Desc")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Service (Coloader/Vendor)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bag Condition")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Desc")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Verification Action")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("STDBag Condition")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Last Modified By")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Manifest InScan Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shortage Type")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bag No")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("REC Reason")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("View")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eba9d82","hasScoped":true}!./src/views/components/AddEditRaiseDEPSLoggedByCLT/AddEditRaiseDEPSLoggedByCLT.component.html
// module id = 535
// module chunks = 1